import Accordion from '@/common/components/Accordion'
import { AvailableTokensAccordion } from '@/common/components/AvailableTokensAccordion'
import HighlightTextArea from '@/common/components/HighlightTextArea'
import SelectController from '@/common/components/SelectController'
import { useBillingBillsDescriptionTokens } from '@/common/hooks/queries/useBillingBillsDescriptionTokens'
import { Mapper } from '@/common/services/mapper'
import { fiscalDocumentKindOptions } from '@/features/privateCompanies/constants/fiscalDocumentKind.constant'
import { CompanyBranchValidationSchema } from '@/features/privateCompanies/schemas/createBranch.schema'
import { FiscalDocumentInformationData } from '@/features/privateCompanies/types/companyBranches.type'
import { Control, Controller, FieldErrors } from 'react-hook-form'
import { BillingBillsDescriptionTokensTransformer } from '../../services/billingBillsDescriptionTokensTransformer'

interface FiscalDocumentInformationProps {
  fiscal_document_information?: FiscalDocumentInformationData
  control: Control<CompanyBranchValidationSchema, any>
  errors: FieldErrors<CompanyBranchValidationSchema>
  disabled?: boolean
}

export const FiscalDocumentInformation = ({
  fiscal_document_information,
  control,
  errors,
  disabled,
}: FiscalDocumentInformationProps) => {
  const { data: descriptionTokens, dataUpdatedAt } = useBillingBillsDescriptionTokens({
    mapper: Mapper.mapWithTransformer({ transformer: BillingBillsDescriptionTokensTransformer.suggestionsTransformer() })
  });

  return (
    <Accordion
      className="py-1"
      name="fiscal_document_information"
      head={<p>Detalhes Fiscais</p>}
      body={
        <div className="flex flex-col gap-4">
          <SelectController
            control={control}
            name="fiscal_document_information_attributes.fiscal_document_kind"
            label="Tipo de Documento Fiscal"
            errorMessage={errors?.fiscal_document_information_attributes?.fiscal_document_kind?.message}
            options={[...fiscalDocumentKindOptions]}
            isDisabled={disabled}
          />

          <Controller
            control={control}
            name="fiscal_document_information_attributes.consumption_observations"
            defaultValue={fiscal_document_information?.consumption_observations}
            disabled={disabled}
            render={({ field: { value, ...rest } }) => (
              <HighlightTextArea
                label="NF de Consumo"
                rows={16}
                maxLength={1024}
                value={value as string | undefined}
                {...rest}
                errorMessage={errors?.fiscal_document_information_attributes?.consumption_observations?.message}
                disabled={disabled}
                suggestions={descriptionTokens}
              />
            )}
          />

          <Controller
            control={control}
            name="fiscal_document_information_attributes.service_observations"
            defaultValue={fiscal_document_information?.service_observations}
            disabled={disabled}
            render={({ field: { value, ...rest } }) => (
              <HighlightTextArea
                label="NF de Tarifas"
                rows={16}
                maxLength={1024}
                value={value as string | undefined}
                {...rest}
                errorMessage={errors?.fiscal_document_information_attributes?.service_observations?.message}
                disabled={disabled}
                suggestions={descriptionTokens}
              />
            )}
          />

          <AvailableTokensAccordion descriptionTokens={descriptionTokens} updatedAt={dataUpdatedAt} />
        </div>
      }
    />
  )
}
